<template>
  <div class="padded">
    <b-nav>
      <b-nav-item to="/" active>Home</b-nav-item>
      <b-nav-item to="faq" active>FAQ</b-nav-item>
      <b-nav-item to="collectors">Collector list</b-nav-item>
      <b-nav-item to="collector-admin">Collector admin</b-nav-item>
      <b-nav-item href="https://www.neilmendoza.com/contact/" target="_blank">Contact</b-nav-item>
    </b-nav>
  </div>
<!--<div class="on-the-left">
    Buy <a href="withdraw">Withdraw funds</a> Admin
</div>-->
</template>

<script>
export default {
  name: 'nav-bar'
}
</script>

<style scoped>
.on-the-left {
  text-align:left;
}

.padded {
  padding: 0 10pc;
}
</style>


// WEBPACK FOOTER //
// src/components/NavBar.vue